import { render, staticRenderFns } from "./TextSelection.vue.js?vue&type=template&id=c7676de4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextSelection.vue?vue&type=template&id=c7676de4"
import script from "./TextSelection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextSelection.vue?vue&type=script&lang=js"
export * from "./TextSelection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextSelection.vue?vue&type=script&lang=js"
import style0 from "./TextSelection.vue.scss?vue&type=style&index=0&id=c7676de4&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextSelection.vue?vue&type=style&index=0&id=c7676de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports